module.exports = __webpack_public_path__ + "img/logo-color.1de8714f.webp";